import { fabric } from 'fabric';
import { Check, Spline } from 'lucide-react';
import { useLingui } from '@lingui/react/macro';
import polygonEdit from 'modules/overlay-canvas/addons/polygon-edit';
import UDText from 'ud-ui/components/text';
import { resizeLinearGradient } from 'shared/fabric';
import { Button, Item } from '../styles';
import { theme } from 'styles/theme/theme';

interface PolygonPointsProps {
  polygon: fabric.Polygon;
  isEditing: boolean;
}

/**
 * Кнопка режима «Изменить точки». Жесты режима — двойной клик и Esc — не видны на канве, поэтому подсказка о них
 * стоит под кнопкой, пока режим включён.
 */
function PolygonPoints(props: PolygonPointsProps) {
  const { polygon, isEditing } = props;
  const { t } = useLingui();

  const onToggle = () => {
    polygonEdit.toggle(polygon, {
      // Градиент в пикселях объекта: без пересборки он перестанет покрывать фигуру с новой рамкой.
      onResize: (from, to) => polygon.set({ fill: resizeLinearGradient(polygon.fill, from, to) }),
    });
  };

  const Icon = isEditing ? Check : Spline;

  return (
    <Item>
      <Button
        className={'flex-center'}
        aria-pressed={isEditing}
        onClick={onToggle}
        icon={<Icon size={16} color={theme.colors.Gray96} />}
      >
        {isEditing ? t`Закончить правку точек` : t`Изменить точки`}
      </Button>
      {isEditing && (
        <UDText type={'caption-1'}>
          {t`Тащите точку мышью. Двойной клик по ребру — новая точка, по точке — удалить её. Esc — выйти.`}
        </UDText>
      )}
    </Item>
  );
}

export default PolygonPoints;
